/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

<template>
  <div>
    <div class="ui inverted top fixed menu">
        <div class="ui container">
            <router-link to="/"
                         class="header item">
                <img class="ui mini image"
                     src="./assets/logo.svg">
                &nbsp;
                Brown-Forman Capability Assessment
            </router-link>
            <router-link to="/login"
                         class="item"
                         v-if="authState && !authState.isAuthenticated">
                Login
            </router-link>
            <router-link to="/messages"
                         class="item"
                         id="messages-button"
                         v-if="getIsAuthenticated && seeMessagesPage">
                <i aria-hidden="true"
                   class="mail outline icon">
                </i>
                Messages
            </router-link>
            <router-link to="/profile"
                         class="item"
                         id="profile-button"
                         v-if="getIsAuthenticated && seeProfilePage">
                Profile
            </router-link>
            <router-link to="/capability"
                         class="item"
                         id="capability-button"
                         v-if="getIsAuthenticated">
                Capability
            </router-link>
            <router-link to="/staff"
                         class="item"
                         id="messages-button"
                         v-if="getIsAuthenticated && userHasStaff">
                My Staff
            </router-link>
            <a id="logout-button"
               class="item"
               v-if="getIsAuthenticated"
               @click="logout()">
                Logout
            </a>
            <span style="flex-grow: 1"></span>
            <span>
              <span class="navigationLoadingIcon" v-show="isNavLoaderVisible">
                  Saving <img src="@/assets/img/loading.gif" />
              </span>
            </span>
        </div>
    </div>
    <div class="ui text container" >
      <router-view v-on:navLoadingStart="navLoadingStart" v-on:navLoadingStop="navLoadingStop" />
    </div>
  </div>
</template>

<style lang="scss">
  @import "@/assets/scss/App.scss";
</style>

<script>
  import _successionControllerAPI from '@/mixins/_successionControllerAPI'
  import { mapGetters } from 'vuex';


  export default {
    name: 'app',
    mixins: [_successionControllerAPI],
    data() {
      return {
        seeMessagesPage: false,
        seeProfilePage: false,
        seeNavLoader: false,
        userHasStaff: true
      }
    },
    computed: {
      ...mapGetters([
            'getIsAuthenticated'
        ]), 
      isNavLoaderVisible() {
        return this.seeNavLoader;
      }
    },
    methods: {
      navLoadingStart() {
        let self = this;
        self.seeNavLoader = true;
      },
      navLoadingStop() {
        let self = this;
        setTimeout(() => self.seeNavLoader = false, 300);
      },
      // async logout () {
      //   const publicPath = this.$route.href.replace(new RegExp(this.$route.fullPath + '$'), '');
      //   await this.$auth.signOut({ postLogoutRedirectUri: `${window.location.origin}${publicPath}` })
      // }
    }
  }
</script>
